export const tableHeaders = {
  customers: [
    {
      text: "",
      value: "status",
      width: 0,
      align: "start",
    },
    {
      text: "",
      sortable: false,
      value: "avatar",
      width: 0,
      align: "start",
    },
    {
      text: "n°",
      value: "nClient",
      width: 65,
      align: "start",
    },
    {
      text: "Nom",
      value: "lastName",
      width: 75,
      align: "start",
    },
    {
      text: "Prénom",
      value: "firstName",
      align: "start",
    },
    {
      text: "",
      sortable: false,
      value: "manage",
      width: 140,
    },
  ],

  companies: [
    {
      text: "",
      value: "status",
      width: 0,
      align: "start",
    },
    {
      text: "",
      sortable: false,
      value: "avatar",
      width: 0,
      align: "start",
    },
    {
      text: "n°",
      value: "nCompany",
      width: 65,
      align: "start",
    },
    {
      text: "Entreprise",
      value: "name",
    },
    {
      text: "",
      sortable: false,
      value: "manage",
      width: 140,
    },
  ],

  products: [
    {
      text: "",
      value: "status",
      width: 10,
      align: "start",
    },
    {
      text: "",
      value: "pictures",
      sortable: false,
      width: 50,
    },

    {
      text: "Référence",
      value: "reference",
      width: 100,
    },
    {
      text: "Prix",
      value: "value",
      width: 100,
    },
    {
      text: "Nom",
      value: "name",
    },
    {
      align: "end",
      text: "",
      value: "manage",
      width: 140,
      sortable: false,
    },
  ],

  warehouseProducts: [
    {
      text: "",
      value: "status",
      width: 10,
      align: "start",
    },
    {
      text: "",
      value: "pictures",
      sortable: false,
      width: 50,
    },
    {
      text: "Référence",
      value: "reference",
      width: 100,
    },
    {
      text: "Prix",
      value: "value",
      width: 100,
    },
    {
      text: "Nom",
      value: "name",
    },
    {
      text: "Stock",
      value: "stock",
      width: 100,
      align: "center",
      editable: true,
    },
    {
      text: "Minimum",
      value: "minimum",
      width: 120,
      align: "center",
      editable: true,
    },
    {
      align: "end",
      text: "",
      value: "manage",
      width: 140,
      sortable: false,
    },
  ],

  projects: [
    {
      text: "",
      value: "status",
      width: 10,
      align: "start",
    },
    {
      sortable: false,
      value: "avatar",
      width: 0,
    },
    {
      text: "Intitulé",
      sortable: false,
      value: "title",
      width: 300,
    },
    {
      text: "Client",
      value: "customers",
    },
    {
      text: "Type",
      value: "type",
      width: 100,
    },
    {
      text: "Valeur",
      value: "value",
      width: 100,
    },
    {
      text: "Date de rendu",
      value: "due",
      width: 150,
    },
    {
      text: "",
      sortable: false,
      value: "manage",
      width: 140,
    },
  ],

  quotes: [
    {
      text: "",
      value: "status",
      width: 10,
      align: "start",
    },
    {
      align: "start",
      sortable: false,
    },
    {
      text: "N°",
      value: "nQuote",
      width: 100,
    },
    {
      text: "Référence",
      value: "reference",
      width: 150,
    },
    {
      text: "Client",
      value: "customer",
    },
    {
      text: "Prix",
      value: "value",
      width: 200,
    },

    {
      text: "",
      align: "end",
      value: "manage",
    },
  ],

  invoices: [
    {
      text: "",
      value: "status",
      width: 10,
      align: "start",
    },
    {
      align: "start",
      sortable: false,
    },
    {
      text: "N°",
      value: "nInvoice",
      width: 100,
    },
    {
      text: "Référence",
      value: "reference",
      width: 150,
    },
    {
      text: "Client",
      value: "customer",
    },
    {
      text: "Prix",
      value: "value",
      width: 200,
    },

    {
      text: "",
      align: "end",
      value: "manage",
    },
  ],

  quoteElements: [
    {
      text: "Quantité",
      align: "center",
      sortable: false,
      width: 100,
      value: "quantity",
    },
    {
      text: "Produit",
      align: "start",
      value: "product",
    },
    {
      text: "Prix unité",
      align: "center",
      width: 140,
      value: "value",
    },
    {
      text: "TVA %",
      align: "center",
      width: 90,
      value: "taxRate",
    },
    {
      text: "Total",
      align: "center",
      width: 140,
      value: "total",
    },
  ],

  tasks: [
    {
      text: "",
      value: "status",
      align: "start",
      width: 0,
    },
    {
      text: "Catégorie",
      value: "category",
      width: 10,
    },
    {
      text: "Tâche",
      value: "task",
      groupable: false,
      align: "left",
      width: 300,
    },
    {
      text: "Priorité",
      value: "priority",
      width: 150,
    },
    {
      text: "Deadline",
      value: "dueDate",
      groupable: false,
      width: 100,
    },
    {
      text: "Particip.",
      value: "participants",
      groupable: false,
      width: 160,
    },
    {
      text: "Projet",
      value: "projectData.title",
      groupable: false,
      width: 82,
    },
    {
      text: "",
      value: "manage",
      groupable: false,
      align: "right",
      width: 200,
    },
  ],

  remarks: [
    {
      text: "Date",
      value: "creationDate",
      width: 170,
    },
    {
      text: "Auteur",
      value: "author",
      width: 170,
    },
    {
      text: "Sujet",
      value: "subject",
    },
    {
      text: "Type",
      value: "type",
    },
  ],

  blogs: [
    {
      text: "Nom",
      value: "name",
    },
    {
      text: "Date de création",
      value: "creationDate",
    },
    {
      text: "Actions",
      align: "center",
      value: "actions",
      sortable: false,
    },
  ],

  ia: [
    {
      text: "Commande",
      value: "command",
    },
    {
      text: "Auteur",
      value: "author",
    },
    {
      text: "Tokens",
      value: "tokens",
    },
    {
      text: "Date de création",
      value: "creationDate",
    },
  ],

  warehouses: [
    {
      text: "Nom",
      value: "name",
    },
    {
      align: "end",
      text: "",
      value: "manage",
      width: 180,
      sortable: false,
    },
  ],

  files: [
    {
      text: "Nom",
      value: "name",
    },
    {
      text: "Auteur",
      value: "author",
    },
    {
      text: "Date d'envoi",
      value: "creationDate",
    },
    {
      text: "",
      sortable: false,
      value: "manageDocument",
      width: "200",
    },
  ],
};
